import {
  withCompPreviewProps,
  createComponentPreviewMapperModel,
} from '@wix/editor-elements-integrations';
import { CompInfoDependency } from '@wix/editor-elements-types';
import {
  HtmlComponentDefinition,
  HtmlComponentProps,
} from '../HtmlComponent.types';
import { props as viewerPropsMapper } from './HtmlComponent.mapper';

const viewerDeps = Object.keys(viewerPropsMapper.deps) as Array<
  CompInfoDependency
>;

const props = withCompPreviewProps<
  HtmlComponentProps,
  HtmlComponentDefinition,
  HtmlComponentProps
>()(['shouldResetComponent', ...viewerDeps], (deps, carmiData) => ({
  ...viewerPropsMapper.resolver(deps, carmiData),
  previewWrapperProps: {
    shouldResetComponent: deps.shouldResetComponent,
  },
}));

export default createComponentPreviewMapperModel({ props });
